import { AuthorizedLayout } from '../layouts/AuthorizedLayout';
import NotAuthorizedLayout from '../layouts/NotAuthorizedLayout';
import AcademicStructure from '../views/AcademicStructure';
import PeriodRecordCreate from '../views/AcademicStructure/periods/PeriodRecordCreate';
import PeriodRecordEdit from '../views/AcademicStructure/periods/PeriodRecordEdit';
import ScheduleRecordCreate from '../views/AcademicStructure/schedule/ScheduleRecordCreate';
import ScheduleRecordEdit from '../views/AcademicStructure/schedule/ScheduleRecordEdit';
import { PermissionName } from '../types/Auth';
import AcademicRecord from '../views/AcademicRecord';
import TuitionProcessOnSite from '../views/AdmissionAndEnrollments/OnSiteEnrollment/TuitionProcessSearchStudent/TuitionProcessOnSite';
import { SearchStudentOnSite } from '../views/AdmissionAndEnrollments/OnSiteEnrollment/TuitionProcessSearchStudent/onSite/SearchStudentOnSite';
import TariffAndTuition from '../views/AdmissionAndEnrollments/TariffAndTuition';
import AdmissionsList from '../views/AdmissionAndEnrollments/AdmissionManagement/AdmissionsList';
import AdmissionsListWithTabs from '../views/AdmissionAndEnrollments/AdmissionManagement/AdmissionsListWithTabs';
import AdmissionsPendingList from '../views/AdmissionAndEnrollments/AdmissionManagement/AdmissionsPendingList';
import AdmissionProcesses from '../views/academicOffers/AdmissionProcesses';
import AdmissionProcessManagement from '../views/academicOffers/AdmissionProcesses/AdmissionProcessManagement';
import ChangePassword from '../views/ChangePassword/ChangePassword';
import ClosingPeriod from '../views/ClosingPeriod/ClosingPeriod';
import Configurations from '../views/Configurations/Configurations';
import UpdateCourseRegistration from '../views/CourseRegistration/CourseRegistration';
import DetailCourseRegistration from '../views/CourseRegistration/DetailCourseRegistration';
import CourseValidationInternal from '../views/CourseValidationInternal';
import CourseValidationInternalStudent from '../views/CourseValidationInternalStudent';
import CurriculumProgress from '../views/CurriculumProgress';
import CurriculumProgressStudent from '../views/CurriculumProgressStudent';
import GraduatesList from '../views/GraduatesList/GraduatesList';
import GraduatesListProcessMassive from '../views/GraduatesListProcessMassive/GraduatesListProcessMassive';
import GraduationProcessMasive from '../views/GraduationProcessMasive/GraduationProcessMasive';
import { GraduationProcessSingle } from '../views/GraduationProcessSingle/GraduationProcessSingle';
import GraduationProcessSinglePendingRequirerments from '../views/GraduationProcessSinglePendingRequirerments/GraduationProcessSinglePendingRequirerments';
import InterimDegreeCurriculums from '../views/academicOffers/InterimDegree/Curriculums';
import InterimDegreeCreate from '../views/academicOffers/InterimDegree/InterimDegreeCreate';
import InterimDegreeEdit from '../views/academicOffers/InterimDegree/InterimDegreeEdit';
import InterimDegreeShow from '../views/academicOffers/InterimDegree/InterimDegreeShow';
import InterimDegreeInterimDegrees from '../views/academicOffers/InterimDegree/InterimDegrees';
import Login from '../views/Login/Login';
import PackagesList from '../views/Packages/PackagesList';
import PackagesPendingStudents from '../views/Packages/PackagesPendingStudents';
import PackagesView from '../views/Packages/PackagesView';
import SectionsAndPackagesList from '../views/PackagesMaintainer/SectionsAndPackagesList';
import SectionsAndPackagesView from '../views/PackagesMaintainer/SectionsAndPackagesView';
import PaymentHub from '../views/PaymentHub';
import Reports from '../views/ManagementTools/Reports';
import SectionAttributesList from '../views/SectionAttributes/SectionAttributesList';
import SectionAttributesView from '../views/SectionAttributes/SectionAttributesView';
import SectionUpdate from '../views/SectionsMaintainer/SectionUpdate';
import SectionsMaintainer from '../views/SectionsMaintainer/SectionsMaintainer';
import CreateSectionForm from '../views/SectionsMaintainer/parts/CreateSectionForm';
import ChangeStudyPlanList from '../views/StudentManagement/EnrollmentSoftChange';
import ChangePeriodOrSchedule from '../views/StudentManagement/EnrollmentSoftChange/EnrollmentSoftChange';
import ContinuityChangeStudyPlan from '../views/StudentManagement/EnrollmentSoftChange/EnrollmentSoftChangeContinuity';
import StudentFile from '../views/StudentManagement/StudentFile';
import UpdateStudentFile from '../views/updateStudentFile';
import StudentStatus from '../views/StudentStatus';
import StudentsDegree from '../views/StudentsDegree';
import StudentsDegreeStudent from '../views/StudentsDegreeStudent';
import StudentsPetitionsDetail from '../views/StudentsPetitionsDetail';
import StudentPetitions from '../views/StudentsPetitionsList';
import { StudentsPostCloseDetail } from '../views/StudentsPostCloseDetail/StudentsPostCloseDetail';
import { StudentsPostCloseSearch } from '../views/StudentsPostCloseSearch/StudentsPostCloseSearch';
import TuitionContinuityProcessDocumentReview from '../views/TuitionContinuityProcessDocumentReview';
import TuitionContinuityProcessDocumentReviewDetail from '../views/TuitionContinuityProcessDocumentReviewDetail';
import TuitionContinuityProcessDocumentReviewDocuments from '../views/TuitionContinuityProcessDocumentReviewDocuments';
import TuitionContinuityProcessManagement from '../views/TuitionContinuityProcessManagement/TuitionContinuityProcessManagement';
import TuitionContinuityProcessManagementDetail from '../views/TuitionContinuityProcessManagementDetail/TuitionContinuityProcessManagementDetail';
import TuitionContinuityTariffAndTuition from '../views/TuitionContinuityTariffAndTuition';
import CoursesMaintainer from '../views/academicOffers/courses';
import CourseUpdate from '../views/academicOffers/courses/CourseUpdate';
import StudyPlansList from '../views/academicOffers/studyPlans';
import CurriculumCreate from '../views/academicOffers/studyPlans/curriculum/views/CurriculumCreate';
import CurriculumCreateMention from '../views/academicOffers/studyPlans/curriculum/views/CurriculumCreateMention';
import CurriculumEdit from '../views/academicOffers/studyPlans/curriculum/views/CurriculumEdit';
import CurriculumEditMetion from '../views/academicOffers/studyPlans/curriculum/views/CurriculumEditMetion';
import CurriculumListMention from '../views/academicOffers/studyPlans/curriculum/views/CurriculumListMention';
import CurriculumView from '../views/academicOffers/studyPlans/curriculum/views/CurriculumView';
import CurriculumViewMetion from '../views/academicOffers/studyPlans/curriculum/views/CurriculumViewMetion';
import StudyPlanRecordCreate from '../views/academicOffers/studyPlans/parts/StudyPlanRecordCreate';
import StudyPlanRecordEdit from '../views/academicOffers/studyPlans/parts/StudyPlanRecordEdit';
import VersionRecordCreate from '../views/academicOffers/studyPlans/version/parts/VersionRecordCreate';
import AcademicOffersList from '../views/academicOffers/vacant-offers';
import AcademicOffersCreate from '../views/academicOffers/vacant-offers/AcademicOffersCreate';
import AcademicOffersEdit from '../views/academicOffers/vacant-offers/AcademicOffersEdit';
import AcademicOffersView from '../views/academicOffers/vacant-offers/AcademicOffersView';
import { DocumentsGridCards } from '../views/documents/DocumentsGridCards';
import { DocumentsList } from '../views/documents/DocumentsList';
import PeriodEndReview from '../views/periodEndReview/PeriodEndReview';
import { SHOW_PAYMENT_HUB } from './constants';
import InterimDegreeGraduationProcessMassive from '../views/InterimDegreeGraduationProcess/Massive';
import InterimDegreeGraduationProcessStudents from '../views/InterimDegreeGraduationProcess/ProcessStudents';
import InterimDegreeGraduationStudents from '../views/InterimDegreeGraduationProcess/Students';
import InterimDegreeGraduationProcessSingle from '../views/InterimDegreeGraduationProcess/Single';
import InterimDegreeGraduationProcessFailedResumen from '../views/InterimDegreeGraduationProcess/FailedResumen';
import InterimDegreeGraduationProcessActivitiesResumen from '../views/InterimDegreeGraduationProcess/ActivitiesResumen';
import TeacherCreate from '../views/TeacherManagement/TeacherActivation';
import TeacherInformation from '../views/TeacherManagement/TeacherFile/TeacherInformation';
import TeacherFile from '../views/TeacherManagement/TeacherFile/TeacherList';
import UsersAndRoles from '../views/ManagementTools/UsersAndRoles';
import UserNew from '../views/ManagementTools/UsersAndRoles/User/UserNew/UserNew';
import RoleManage from '../views/ManagementTools/UsersAndRoles/Role/RoleManage';
import RolePermission from '../views/ManagementTools/UsersAndRoles/Role/RoleManage/parts/RolePermission';
import StudentCurrentAccount from '../views/StudentCurrentAccount';
import GradingStructureEdit from '../views/Configurations/GradingStructure/Edit';
import tuitionContinuityDiscountAllocation from '../views/TuitionContinuityDiscountAllocation';
import tuitionContinuityDiscountAllocationManagement from '../views/TuitionContinuityDiscountManagement';
import DebtDetail from '../views/StudentCurrentAccount/DebtDetail';
import Coursables from '../views/ManagementTools/Reports/Coursables';
import Surveys from '../views/ManagementTools/Surveys';
import SurveyCreate from '../views/ManagementTools/Surveys/parts/SurveyCreate';
import SurveyEdit from '../views/ManagementTools/Surveys/parts/SurveyEdit/index';
import SurveyEvaluationScales from '../views/ManagementTools/SurveyEvaluationScales';
import SurveyEvaluationScalesCreate from '../views/ManagementTools/SurveyEvaluationScales/parts/CreateEvaluationScale';
import SurveyEvaluationScalesEdit from '../views/ManagementTools/SurveyEvaluationScales/parts/EditEvaluationScale';
import SurveyResultsList from '../views/ManagementTools/SurveyResults';
import TutorAssignment from '../views/TeacherManagement/TutorAssignment';
import SectionsRegistrationMassive from '../views/SectionsRegistrationMassive';
import AnnouncementAdminList from '../views/Announcement/AnnouncementAdminList';
import AnnouncementList from '../views/Announcement/AnnouncementList';
import { TeacherAttendance } from '../views/TeacherManagement/TeacherAttendance';
import PerformanceAnalysisList from '../views/ManagementTools/PerformanceAnalysis';
import Classrooms from '../views/ManagementTools/Classrooms';
import { ClassroomCalendar } from '../views/ManagementTools/Classrooms/ClassroomCalendar';
import { StudentsRemovalRequest } from '../views/StudentManagement/StudentsRemovalRequest';
import { StudentsRemovalRequestsManage } from '../views/StudentManagement/StudentsRemovalRequestManage';
import { StudentsRemovalRequestPendingDetails } from '../views/StudentManagement/StudentsRemovalRequestManage/StudentsRemovalRequestsPending/StudentsRemovalRequestPendingDetails';
import { StudentsRemovalRequestView } from '../modules/StudentRemovalRequestView';
import StudentWarnings from '../views/StudentWarnings';
import StudentWarningsDetails from '../views/StudentWarnings/StudentWarningsDetails';
import VersionRecordEdit from '../views/academicOffers/studyPlans/version/parts/VersionRecordEdit';
import ContainerCreateCeia from '../views/StudentWarnings/views/create';
import { ContainerUpdateCeia } from '../views/StudentWarnings/views/update';
import { PaymentHubDebts } from '../views/PaymentHub/Debts/parts/PaymentHubDebts';
import StudentRiskEvaluationSessionStudents from '../views/StudentWarnings/StudentRiskEvaluationSessionStudents';
import { StudentSessionDetailContainer } from '../views/StudentWarnings/views/studentSessionDetail';
import { StudentRiskHistoryDetails } from '../views/StudentWarnings/parts/StudentRiskHistory/StudentListDetails';
import StudentObservationsDetails from '../views/StudentWarnings/parts/Observations/Details/StudentObservationsDetails';
import { PaymentHubNoSaleNotes } from '../views/PaymentHub/NonSalenotes/parts/PaymentHubNoSaleNotes';
import Sections from '../views/ContinuousEducation/Sections';
import SectionsCreate from '../views/ContinuousEducation/Sections/parts/SectionsCreate';
import { CeStudyPlans } from '../views/ContinuousEducation/StudyPlans';
import SectionsEdit from '../views/ContinuousEducation/SectionsEdit';
import { CreateCourse } from '../views/ContinuousEducation/StudyPlans/views/CreateCourse';
import { CreateProgram } from '../views/ContinuousEducation/StudyPlans/views/CreateProgram';
import { UpdateCourse } from '../views/ContinuousEducation/StudyPlans/views/UpdateCourse';
import { UpdateProgram } from '../views/ContinuousEducation/StudyPlans/views/UpdateProgram';
import { AcademicOffers as CeAcademicOffers } from '../views/ContinuousEducation/AcademicOffers';
import { Certificates as CeCertificates } from '../views/ContinuousEducation/Certificates';
import { CeAcademicOfferWizard } from '../views/ContinuousEducation/AcademicOffers/context/AcademicOfferWizard';
import CEClosingPeriod from '../views/CEClosingPeriod/CEClosingPeriod';
import ContinuousEducationPeriodEndReview from '../views/ContinuousEducation/ContinuousEducationPeriodEndReview/ContinuousEducationPeriodEndReview';
import { CertificatesStudents } from '../views/ContinuousEducation/Certificates/parts/CertificatesStudents';

export enum PathsLayouts {
  auth = '/auth',
  announcementsAdmin = '/management-tools/announcements',
  announcements = '/announcements',
  academicStructure = '/maintainers',
  academicOffers = '/academic-offers',
  currentAccount = '/current-account',
  tuitionProcess = '/tuition-process',
  tariffAndTuiton = '/tariff-tuiton',
  admissions = '/admissions',
  admissionProcesses = '/academic-offer/admission-processes',
  documents = '/documents',
  packages = '/packages',
  packagesMaintainer = '/packages-maintainer',
  reports = '/reports',
  courseRegistration = '/course-registration',
  sectionAttributes = '/section-attributes',
  sectionsMaintainer = '/sections-maintainer',
  sectionsRegistrationMassive = '/sections-registration-massive',
  teacherFile = '/teacher-file',
  teacherActivation = '/teachers-activation',
  studentStatus = '/student-status',
  studentFile = '/student-file',
  curriculumProgress = '/avance-curricular',
  closingPeriod = '/closing-period',
  configurations = '/config',
  studentsPostClose = '/students-post-close',
  tuitionContinuityProcessManagement = '/tuition-continuity-process-management',
  graduationProcessMassive = '/graduation-process-massive',
  graduationProcessSingle = '/graduation-process-single',
  graduatesList = '/graduates-list',
  tuitionContinuityTariffAndTuition = '/tuition-continuity-tariff-tuition',
  tuitionContinuityDocumentReview = '/tuition-continuity-document-review',
  tuitionContinuityDiscountAllocation = '/tuition-continuity-discount-allocation',
  tuitionContinuityDiscountManagement = '/tuition-continuity-discount-management',
  courseValidationInternal = '/convalidacion-interna',
  academicRecord = '/record-academico',
  paymentHub = '/centro-pagos',
  studentPetitions = '/student-petitions',
  studentsDegree = '/students-degree',
  studentsRemovalRequest = '/students-removal-request',
  studentsRemovalRequestsManage = '/students-removal-request-manage',
  enrollmentSoftChange = '/enrollment-soft-change',
  usersAndRoles = '/users-and-roles',
  surveys = '/surveys',
  surveyResults = '/survey-results',
  surveyEvaluationScales = '/survey-evaluation-scales',
  interimDegreeGraduationProcess = '/interim-degree-graduation-process',
  studentCheckingAccount = '/student-checking-account',
  tutorManagement = '/tutor-management',
  teacherAttendances = '/teacher-attendances',
  performanceAnalysis = '/performance-analysis',
  classrooms = '/classrooms',
  studentWarnings = '/student-warnings',
  continuousEducation = '/continuous-education',
}

export type ViewRouteType = {
  path: string;
  component: () => JSX.Element;
  requiredPermissions?: PermissionName[];
};

export type RoutesByLayout = {
  // this keys are the paths of every layout
  [key in PathsLayouts]?: {
    layoutComponent: () => JSX.Element;
    defaultPath: string;
    views: ViewRouteType[];
    requiredPermissions?: PermissionName[];
    allPermissionsRequired?: boolean;
    disabled?: boolean;
  };
};

/**
 * Contiene todos los layouts con sus vistas
 */
export const NOT_AUTHORIZED_ROUTES: RoutesByLayout = {
  [PathsLayouts.auth]: {
    layoutComponent: NotAuthorizedLayout,
    defaultPath: '/login',
    views: [
      {
        path: '/login',
        component: Login,
      },
      {
        path: '/activate-account',
        component: ChangePassword,
      },
      {
        path: '/reset-password',
        component: ChangePassword,
      },
    ],
  },
};

export const AUTHORIZED_ROUTES: RoutesByLayout = {
  [PathsLayouts.academicStructure]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/periods',
    requiredPermissions: [PermissionName.ACADEMIC_STRUCTURE],
    views: [
      {
        path: '/periods',
        component: AcademicStructure,
      },
      {
        path: '/periods/record',
        component: PeriodRecordCreate,
      },
      {
        path: '/periods/record/:id',
        component: PeriodRecordEdit,
      },
      {
        path: '/campus',
        component: AcademicStructure,
      },
      {
        path: '/schools',
        component: AcademicStructure,
      },
      {
        path: '/schedules',
        component: AcademicStructure,
      },
      {
        path: '/schedules/record',
        component: ScheduleRecordCreate,
      },
      {
        path: '/schedules/record/:id',
        component: ScheduleRecordEdit,
      },
      {
        path: '/modalities',
        component: AcademicStructure,
      },
    ],
  },

  [PathsLayouts.academicOffers]: {
    //requiredPermissions: [PermissionName.ACADEMIC_STRUCTURE],
    layoutComponent: AuthorizedLayout,
    defaultPath: '/study-plans',
    views: [
      //cursos
      {
        path: '/curricular-subjects',
        component: CoursesMaintainer,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_CURRICULAR_SUBJECT],
      },
      {
        path: '/curricular-subjects/create',
        component: CourseUpdate,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_CURRICULAR_SUBJECT],
      },
      {
        path: '/curricular-subjects/watch/:id',
        component: CourseUpdate,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_CURRICULAR_SUBJECT],
      },
      {
        path: '/curricular-subjects/update/:id',
        component: CourseUpdate,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_CURRICULAR_SUBJECT],
      },
      //Planes de estudios
      {
        path: '/study-plans',
        component: StudyPlansList,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_STUDY_PLAN],
      },
      {
        path: '/study-plans/record',
        component: StudyPlanRecordCreate,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_STUDY_PLAN],
      },
      {
        path: '/study-plans/record/:id',
        component: StudyPlanRecordEdit,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_STUDY_PLAN],
      },
      {
        path: '/study-plans/record/:id/version/create', // Create
        component: VersionRecordCreate,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_STUDY_PLAN],
      },
      {
        path: '/study-plans/record/:id/version/:versionId', //Edit
        component: VersionRecordEdit,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_STUDY_PLAN],
      },
      {
        path: '/study-plans/record/:id/version/:versionId/curriculum/create', //Create
        component: CurriculumCreate,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_STUDY_PLAN],
      },
      {
        path:
          '/study-plans/record/:id/version/:versionId/curriculum/:curriculumId', //Edit
        component: CurriculumEdit,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_STUDY_PLAN],
      },
      {
        path:
          '/study-plans/record/:id/version/:versionId/curriculum/:curriculumId/view', //View
        component: CurriculumView,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_STUDY_PLAN],
      },
      {
        path: '/study-plans/record/:id/version/:versionId/mention/create', //Create
        component: CurriculumCreateMention,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_STUDY_PLAN],
      },
      {
        path: '/study-plans/record/:id/version/:versionId/mention/list', //List
        component: CurriculumListMention,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_STUDY_PLAN],
      },
      {
        path: '/study-plans/record/:id/version/:versionId/mention/:mentionId', //Edit
        component: CurriculumEditMetion,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_STUDY_PLAN],
      },
      {
        path:
          '/study-plans/record/:id/version/:versionId/mention/:mentionId/:action', //View
        component: CurriculumViewMetion,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_STUDY_PLAN],
      },
      //Offertas Vacantes
      {
        path: '/vacant-offers',
        component: AcademicOffersList,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_VACANT_OFFER],
      },
      {
        path: '/vacant-offers/record',
        component: AcademicOffersCreate,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_VACANT_OFFER],
      },
      {
        path: '/vacant-offers/record/:id',
        component: AcademicOffersEdit,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_VACANT_OFFER],
      },
      {
        path: '/vacant-offers/info/:id',
        component: AcademicOffersView,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_VACANT_OFFER],
      },
      // Titulos intermedios
      {
        path: '/interim-degree/create/:curriculumId',
        component: InterimDegreeCreate,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_INTERIM_DEGREE],
      },
      {
        path: '/interim-degree/show/:interimDegreeId',
        component: InterimDegreeShow,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_INTERIM_DEGREE],
      },
      {
        path: '/interim-degree/edit/:interimDegreeId',
        component: InterimDegreeEdit,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_INTERIM_DEGREE],
      },
      {
        path: '/interim-degree/curriculums',
        component: InterimDegreeCurriculums,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_INTERIM_DEGREE],
      },
      {
        path: '/interim-degree/curriculums/:curriculumId',
        component: InterimDegreeInterimDegrees,
        requiredPermissions: [PermissionName.ACADEMIC_OFFER_INTERIM_DEGREE],
      },
    ],
  },
  [PathsLayouts.currentAccount]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    views: [
      {
        path: '/',
        component: StudentCurrentAccount,
        requiredPermissions: [PermissionName.CURRENT_ACCOUNT],
      },
      {
        path: '/:studentId/debt-detail/:debtId',
        component: DebtDetail,
        requiredPermissions: [PermissionName.CURRENT_ACCOUNT],
      },
    ],
  },
  [PathsLayouts.tuitionProcess]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [
      PermissionName.ADMISSIONS_AND_ENROLLMENTS_TUITION_PROCESS,
    ],
    views: [
      {
        path:
          '/postulation/:postulantId/:postulationDetailId/:admissionType/:fromStart',
        component: TuitionProcessOnSite,
      },
      {
        path: '/',
        component: SearchStudentOnSite,
      },
    ],
  },
  [PathsLayouts.tariffAndTuiton]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/tuitions',
    requiredPermissions: [
      PermissionName.ADMISSIONS_AND_ENROLLMENTS_TARIFFS_AND_DISCOUNTS,
    ],
    views: [
      {
        path: '/tuitions',
        component: TariffAndTuition,
      },
      {
        path: '/tariff',
        component: TariffAndTuition,
      },
      {
        path: '/discounts',
        component: TariffAndTuition,
      },
    ],
  },
  [PathsLayouts.admissions]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [
      PermissionName.ADMISSIONS_AND_ENROLLMENTS_ADMISSION_MANAGEMENT,
    ],
    views: [
      {
        path: '/',
        component: AdmissionsList,
      },
      {
        path: '/postulans-pending',
        component: AdmissionsPendingList,
      },
      {
        path: '/:id/admission-call',
        component: AdmissionsListWithTabs,
      },
      {
        path: '/:id/in-process',
        component: AdmissionsListWithTabs,
      },
      {
        path: '/:id/enrolled',
        component: AdmissionsListWithTabs,
      },
      {
        path: '/:id/dropped',
        component: AdmissionsListWithTabs,
      },
      {
        path: '/:id/waiting-list',
        component: AdmissionsListWithTabs,
      },
      {
        path: '/:id/retracted',
        component: AdmissionsListWithTabs,
      },
    ],
  },
  [PathsLayouts.admissionProcesses]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.ACADEMIC_OFFER_ADMISSION_PROCESSES],
    views: [
      {
        path: '/',
        component: AdmissionProcesses,
      },
      {
        path: '/:id',
        component: AdmissionProcessManagement,
      },
    ],
  },
  [PathsLayouts.documents]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [
      PermissionName.ADMISSIONS_AND_ENROLLMENTS_DOCUMENTATION_REVIEW_PROCESS,
    ],
    views: [
      {
        path: '/',
        component: DocumentsGridCards,
      },
      {
        path: '/:academicOfferStudyPlanVersionOffersId',
        component: DocumentsList,
      },
    ],
  },
  [PathsLayouts.packages]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.SECTIONS_PACKAGES_ALL],
    views: [
      {
        path: '/pending-students/:id',
        component: PackagesPendingStudents,
      },
      {
        path: '/:id',
        component: PackagesView,
      },
      {
        path: '/',
        component: PackagesList,
      },
    ],
  },
  [PathsLayouts.packagesMaintainer]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.SECTION_PACKAGES_LOAD_ALL],
    views: [
      {
        path: '/',
        component: SectionsAndPackagesList,
      },
      { path: '/:periodId', component: SectionsAndPackagesView },
    ],
  },
  [PathsLayouts.courseRegistration]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.ENROLLMENT_MODIFICATION],
    views: [
      { path: '/', component: UpdateCourseRegistration },
      {
        path: '/:accountId/:studyPlanEnrollmentId',
        component: DetailCourseRegistration,
      },
    ],
  },
  [PathsLayouts.reports]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.REPORTS],
    views: [
      {
        path: '/',
        component: Reports,
      },
      {
        path: '/coursables',
        component: Coursables,
      },
    ],
  },
  [PathsLayouts.sectionAttributes]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.SECTION_PACKAGES_LOAD_ALL],
    views: [
      {
        path: '/',
        component: SectionAttributesList,
      },
      { path: '/:periodId', component: SectionAttributesView },
    ],
  },
  [PathsLayouts.sectionsMaintainer]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.SECTIONS_MODIFICATION],
    views: [
      { path: '/create', component: CreateSectionForm },
      { path: '/:sectionId', component: SectionUpdate },
      { path: '/', component: SectionsMaintainer },
    ],
  },
  [PathsLayouts.sectionsRegistrationMassive]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.SECTIONS_REGISTRATION_MASSIVE],
    views: [{ path: '/', component: SectionsRegistrationMassive }],
  },
  [PathsLayouts.teacherActivation]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.TEACHER_MANAGEMENT_ALL],
    views: [{ path: '/', component: TeacherCreate }],
  },
  [PathsLayouts.teacherFile]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.TEACHER_MANAGEMENT_ALL],
    views: [
      { path: '/', component: TeacherFile },
      {
        path: '/:teacherId/personal-background',
        component: TeacherInformation,
      },
      {
        path: '/:teacherId/educational-background',
        component: TeacherInformation,
      },
      {
        path: '/:teacherId/employment-background',
        component: TeacherInformation,
      },
      {
        path: '/:teacherId/assigned-students',
        component: TeacherInformation,
      },
      { path: '/:teacherId/hiring-information', component: TeacherInformation },
      {
        path: '/:teacherId/additional-documentation',
        component: TeacherInformation,
      },
    ],
  },
  [PathsLayouts.usersAndRoles]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/users',
    requiredPermissions: [PermissionName.MANAGEMENT_TOOLS_USERS_AND_ROLES],
    views: [
      { path: '/users', component: UsersAndRoles },
      { path: '/users/create/:id?', component: UserNew },
      { path: '/users/:id/update', component: UserNew },
      { path: '/roles', component: UsersAndRoles },
      { path: '/roles/create/', component: RoleManage },
      { path: '/roles/:roleId/update', component: RoleManage },
      { path: '/roles/:roleId/permissions', component: RolePermission },
    ],
  },
  [PathsLayouts.surveys]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.MANAGEMENT_TOOLS_SURVEYS],
    views: [
      {
        path: '/create/',
        component: SurveyCreate,
      },
      {
        path: '/update/published/:surveyId',
        component: SurveyEdit,
      },
      {
        path: '/update/draft/:draftId',
        component: SurveyEdit,
      },
      { path: '/:state?', component: Surveys },
    ],
  },
  [PathsLayouts.surveyEvaluationScales]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.MANAGEMENT_TOOLS_SURVEYS],
    views: [
      { path: '/', component: SurveyEvaluationScales },
      { path: '/:view/', component: SurveyEvaluationScalesCreate },
      { path: '/:view/:scaleId', component: SurveyEvaluationScalesEdit },
    ],
  },
  [PathsLayouts.surveyResults]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.MANAGEMENT_TOOLS_SURVEYS],
    views: [{ path: '/', component: SurveyResultsList }],
  },
  [PathsLayouts.studentStatus]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.STUDENT_MANAGEMENT_STUDENT_STATUS],
    views: [
      {
        path: '/',
        component: StudentStatus,
      },
    ],
  },
  [PathsLayouts.studentFile]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.STUDENT_MANAGEMENT_STUDENT_FILE],
    views: [
      {
        path: '/',
        component: StudentFile,
      },
      {
        path: '/update/:studentId',
        component: UpdateStudentFile,
      },
    ],
  },
  [PathsLayouts.studentsRemovalRequest]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [
      PermissionName.STUDENT_MANAGEMENT_STUDENTS_REMOVAL_REQUEST,
    ],
    views: [
      {
        path: '/',
        component: StudentsRemovalRequest,
      },
      {
        path: '/:studentRemovalRequestId',
        component: StudentsRemovalRequestView,
      },
    ],
  },
  [PathsLayouts.studentsRemovalRequestsManage]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [
      PermissionName.STUDENT_MANAGEMENT_STUDENTS_REMOVAL_REQUESTS_MANAGE,
    ],
    views: [
      {
        path: '/',
        component: StudentsRemovalRequestsManage,
      },
      {
        path: '/:studyPlanEnrollmentId',
        component: StudentsRemovalRequestPendingDetails,
      },
      {
        path: '/:studentRemovalRequestId/detail',
        component: StudentsRemovalRequestView,
      },
    ],
  },
  [PathsLayouts.curriculumProgress]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.STUDENT_CURRICULUM_PROGRESS_LIST],
    views: [
      {
        path: '/',
        component: CurriculumProgress,
      },
      {
        path: '/:studyPlanEnrollmentId',
        component: CurriculumProgressStudent,
      },
    ],
  },
  [PathsLayouts.closingPeriod]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.SUBJECT_SECTIONS_PERIOD_CLOSE],
    views: [
      {
        path: '/',
        component: ClosingPeriod,
      },
      {
        path: '/:id',
        component: PeriodEndReview,
      },
    ],
  },
  [PathsLayouts.configurations]: {
    layoutComponent: AuthorizedLayout,
    requiredPermissions: [PermissionName.SETTINGS],
    defaultPath: '/',
    views: [
      { path: '/', component: Configurations },
      {
        path: '/grading-structure/:gradesAcademicId',
        component: GradingStructureEdit,
      },
    ],
  },
  [PathsLayouts.studentsPostClose]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.STUDENTS_POST_CLOSE],
    views: [
      { path: '/', component: StudentsPostCloseSearch },
      { path: '/detail', component: StudentsPostCloseDetail },
    ],
  },
  [PathsLayouts.tuitionContinuityProcessManagement]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.TUITION_CONTINUITY_MANAGEMENT],
    views: [
      { path: '/', component: TuitionContinuityProcessManagement },
      {
        path: '/:studyPlanVersionOfferId/period/:periodId',
        component: TuitionContinuityProcessManagementDetail,
      },
    ],
  },
  [PathsLayouts.graduationProcessMassive]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.STUDENT_MANAGEMENT_GRADUATION_PROCESS],
    views: [
      { path: '/', component: GraduationProcessMasive },
      { path: '/graduates-list', component: GraduatesListProcessMassive },
    ],
  },
  [PathsLayouts.graduationProcessSingle]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.STUDENT_MANAGEMENT_GRADUATION_PROCESS],
    views: [
      { path: '/', component: GraduationProcessSingle },
      {
        path: '/pending-requirerments',
        component: GraduationProcessSinglePendingRequirerments,
      },
    ],
  },
  [PathsLayouts.graduatesList]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.STUDENT_MANAGEMENT_GRADUATION_PROCESS],
    views: [{ path: '/', component: GraduatesList }],
  },
  [PathsLayouts.tuitionContinuityTariffAndTuition]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/tuitions',
    requiredPermissions: [PermissionName.TUITION_CONTINUITY_TARIFF_AND_TUITION],
    views: [
      { path: '/tuitions', component: TuitionContinuityTariffAndTuition },
      {
        path: '/tariff',
        component: TuitionContinuityTariffAndTuition,
      },
    ],
  },
  [PathsLayouts.tuitionContinuityDocumentReview]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.TUITION_CONTINUITY_DOCUMENT_REVIEW],
    views: [
      { path: '/', component: TuitionContinuityProcessDocumentReview },
      {
        path: '/student-list/:periodId/:offerId/:status',
        component: TuitionContinuityProcessDocumentReviewDetail,
      },
      {
        path: '/documents/:tcProcessId',
        component: TuitionContinuityProcessDocumentReviewDocuments,
      },
    ],
  },
  [PathsLayouts.tuitionContinuityDiscountAllocation]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [
      PermissionName.TUITION_CONTINUITY_DISCOUNT_ALLOCATION,
    ],
    views: [{ path: '/', component: tuitionContinuityDiscountAllocation }],
  },
  [PathsLayouts.tuitionContinuityDiscountManagement]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [
      PermissionName.TUITION_CONTINUITY_DISCOUNT_MANAGEMENT,
    ],
    views: [
      { path: '/', component: tuitionContinuityDiscountAllocationManagement },
    ],
  },
  [PathsLayouts.courseValidationInternal]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.COURSE_VALIDATION],
    views: [
      {
        path: '/',
        component: CourseValidationInternal,
      },
      {
        path: '/:studyPlanEnrollmentId',
        component: CourseValidationInternalStudent,
      },
    ],
  },
  [PathsLayouts.academicRecord]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.ACADEMIC_RECORD],
    views: [
      {
        path: '/',
        component: AcademicRecord,
      },
    ],
  },
  [PathsLayouts.paymentHub]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/history',
    disabled: !SHOW_PAYMENT_HUB,
    requiredPermissions: [
      PermissionName.PAYMENT_HUB,
      PermissionName.PAYMENT_HUB_DEBTS,
    ],
    views: [
      {
        path: '/history',
        component: PaymentHub,
        requiredPermissions: [PermissionName.PAYMENT_HUB],
      },
      {
        path: '/deudas',
        component: PaymentHubDebts,
        requiredPermissions: [PermissionName.PAYMENT_HUB_DEBTS],
      },
      {
        path: '/sin-notas-de-venta',
        component: PaymentHubNoSaleNotes,
        requiredPermissions: [PermissionName.PAYMENT_HUB_DEBTS],
      },
    ],
  },
  [PathsLayouts.studentPetitions]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/received',
    requiredPermissions: [PermissionName.STUDENT_MANAGEMENT_PETITIONS],
    views: [
      {
        path: '/received',
        component: StudentPetitions,
      },
      {
        path: '/resolved',
        component: StudentPetitions,
      },
      {
        path: '/:petitionId',
        component: StudentsPetitionsDetail,
      },
    ],
  },
  [PathsLayouts.enrollmentSoftChange]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/list',
    requiredPermissions: [
      PermissionName.STUDENT_MANAGEMENT_ENROLLMENT_SOFT_CHANGE,
    ],
    views: [
      {
        path: '/list',
        component: ChangeStudyPlanList,
      },
      {
        path: '/list-continuity',
        component: ChangeStudyPlanList,
      },
      {
        path: '/:studyPlanEnrollmentId',
        component: ChangePeriodOrSchedule,
      },
      {
        path: '/continuity/:studyPlanEnrollmentId',
        component: ContinuityChangeStudyPlan,
      },
    ],
  },
  [PathsLayouts.studentsDegree]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/graduate',
    requiredPermissions: [PermissionName.STUDENT_MANAGEMENT_STUDENTS_DEGREE],
    views: [
      {
        path: '/graduate',
        component: StudentsDegree,
      },
      {
        path: '/titled',
        component: StudentsDegree,
      },
      {
        path: '/:studyPlanEnrollmentId',
        component: StudentsDegreeStudent,
      },
    ],
  },
  [PathsLayouts.interimDegreeGraduationProcess]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/massive',
    requiredPermissions: [PermissionName.INTERIM_DEGREE_GRADUATION_PROCESS_ALL],
    views: [
      {
        path: '/massive',
        component: InterimDegreeGraduationProcessMassive,
      },
      {
        path: '/single',
        component: InterimDegreeGraduationProcessSingle,
      },
      {
        path: '/students',
        component: InterimDegreeGraduationStudents,
      },
      {
        path: '/failed/:studyPlanEnrollmentId/:interimDegreeId',
        component: InterimDegreeGraduationProcessFailedResumen,
      },
      {
        path: '/activities/:interimDegreeAuthorizedStudentId',
        component: InterimDegreeGraduationProcessActivitiesResumen,
      },
      {
        path: '/:processId/:batch',
        component: InterimDegreeGraduationProcessStudents,
      },
    ],
  },
  [PathsLayouts.tutorManagement]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/tutor-assignment',
    requiredPermissions: [PermissionName.TUTOR_MANAGEMENT_MANAGE],
    views: [
      {
        path: '/tutor-assignment',
        component: TutorAssignment,
      },
    ],
  },
  [PathsLayouts.announcementsAdmin]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.MANAGEMENT_TOOLS_ANNOUNCEMENTS],
    views: [
      {
        path: '/',
        component: AnnouncementAdminList,
      },
    ],
  },
  [PathsLayouts.announcements]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    views: [
      {
        path: '/',
        component: AnnouncementList,
      },
    ],
  },
  [PathsLayouts.teacherAttendances]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/teacher-attendances',
    requiredPermissions: [PermissionName.TEACHER_MANAGEMENT_ALL],
    views: [
      {
        path: '/',
        component: TeacherAttendance,
      },
    ],
  },
  [PathsLayouts.performanceAnalysis]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.MANAGEMENT_TOOLS_PERFORMANCE_ANALYSIS],
    views: [
      {
        path: '/',
        component: PerformanceAnalysisList,
      },
    ],
  },
  [PathsLayouts.classrooms]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [PermissionName.MANAGEMENT_TOOLS_CLASSROOMS],
    views: [
      {
        path: '/',
        component: Classrooms,
      },
      {
        path: '/:classroomId/calendar',
        component: ClassroomCalendar,
      },
    ],
  },
  [PathsLayouts.studentWarnings]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/',
    requiredPermissions: [
      PermissionName.STUDENT_WARNINGS_ALERTS_ALL,
      PermissionName.STUDENT_WARNINGS_CONFIG_ALL,
      PermissionName.STUDENT_RISK_EVALUATION_SESSION_ALL,
    ],
    views: [
      {
        path: '/',
        component: StudentWarnings,
        requiredPermissions: [
          PermissionName.STUDENT_WARNINGS_ALERTS_ALL,
          PermissionName.STUDENT_WARNINGS_CONFIG_ALL,
          PermissionName.STUDENT_RISK_EVALUATION_SESSION_ALL,
        ],
      },
      {
        path:
          '/details/:studyPlanEnrollmentId/:periodId/:year/:warningGroupType/:startAt/:endAt',
        component: StudentWarningsDetails,
        requiredPermissions: [PermissionName.STUDENT_WARNINGS_ALERTS_ALL],
      },
      {
        path: '/evaluation-sessions/create',
        component: ContainerCreateCeia,
        requiredPermissions: [
          PermissionName.STUDENT_RISK_EVALUATION_SESSION_ALL,
        ],
      },
      {
        path: '/evaluation-sessions/update/:id',
        component: ContainerUpdateCeia,
        requiredPermissions: [
          PermissionName.STUDENT_RISK_EVALUATION_SESSION_ALL,
        ],
      },
      {
        path: '/evaluation-sessions/students/:id',
        component: StudentRiskEvaluationSessionStudents,
        requiredPermissions: [
          PermissionName.STUDENT_RISK_EVALUATION_SESSION_ALL,
        ],
      },
      {
        path: '/student-risk/history/session-enrollment/:sessionEnrollmentId',
        component: StudentRiskHistoryDetails,
        requiredPermissions: [
          PermissionName.STUDENT_RISK_EVALUATION_SESSION_ALL,
        ],
      },
      {
        path: '/student-risk/:id',
        component: StudentSessionDetailContainer,
        requiredPermissions: [
          PermissionName.STUDENT_RISK_EVALUATION_SESSION_ALL,
        ],
      },
      {
        //Example: http://localhost:4201/student-warnings/observations/details/6797/7398/22/2024
        path:
          '/observations/details/:studentId/:studyPlanEnrollmentId/:periodId/:year',
        component: StudentObservationsDetails,
        requiredPermissions: [
          PermissionName.STUDENT_RISK_EVALUATION_SESSION_ALL,
        ],
      },
    ],
  },
  [PathsLayouts.continuousEducation]: {
    layoutComponent: AuthorizedLayout,
    defaultPath: '/sections',
    requiredPermissions: [PermissionName.CONTINUOUS_EDUCATION],
    views: [
      { path: '/study-plans', component: CeStudyPlans },
      {
        path: '/study-plans/course',
        component: CreateCourse,
      },
      {
        path: '/study-plans/program-course',
        component: CreateProgram,
      },
      {
        path: '/study-plans/course/:id',
        component: UpdateCourse,
      },
      {
        path: '/study-plans/program-course/:id',
        component: UpdateProgram,
      },
      {
        path: '/sections',
        component: Sections,
      },
      {
        path: '/sections/create',
        component: SectionsCreate,
      },
      {
        path: '/sections/:sectionId',
        component: SectionsEdit,
      },
      {
        path: '/academic-offers',
        component: CeAcademicOffers,
      },
      {
        path: '/academic-offers/:id/wizard',
        component: CeAcademicOfferWizard,
      },
      {
        path: '/closing-period',
        component: CEClosingPeriod,
      },
      {
        path: '/closing-period/:id',
        component: ContinuousEducationPeriodEndReview,
        requiredPermissions: [PermissionName.CE_SUBJECT_SECTIONS_PERIOD_CLOSE],
      },
      {
        path: '/certificates',
        component: CeCertificates,
        requiredPermissions: [PermissionName.CE_CERTIFICATES],
      },
      {
        path: '/certificates/:ceAcademicOfferId/students',
        component: CertificatesStudents,
        requiredPermissions: [PermissionName.CE_CERTIFICATES],
      },
    ],
  },
};

export const routes = { ...AUTHORIZED_ROUTES, ...NOT_AUTHORIZED_ROUTES };
